// extracted by mini-css-extract-plugin
export default {"title_wrapper":"NoticeRegister_title_wrapper__pIxfo","input":"NoticeRegister_input__HhFNY","textarea":"NoticeRegister_textarea__rDRg+"};